// removed by extract-text-webpack-plugin
module.exports = {"ui":"identity_ui_7sst5x","inline":"identity_inline_3sv9hn","large":"identity_large_d30bs8","normal":"identity_normal_6hlzf7"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/img/identity/identity.scss
// module id = 521
// module chunks = 0